(function () {
  Flint.file('views/navBar.js', function (require) {
    Flint.staticStyles('NavBar', {
      '$': '#_flintapp .ViewNavBar',
      '$mobileMode': '#_flintapp mobileMode.NavBar, #_flintapp .NavBar.mobileMode, #_flintapp .ViewNavBar.mobileMode, #_flintapp .NavBar > .mobileMode',
      '$desktopMode': '#_flintapp desktopMode.NavBar, #_flintapp .NavBar.desktopMode, #_flintapp .ViewNavBar.desktopMode, #_flintapp .NavBar > .desktopMode',
      '$logoSec': '#_flintapp logoSec.NavBar, #_flintapp .NavBar.logoSec, #_flintapp .ViewNavBar.logoSec, #_flintapp .NavBar > .logoSec',
      '$hamSection': '#_flintapp hamSection.NavBar, #_flintapp .NavBar.hamSection, #_flintapp .ViewNavBar.hamSection, #_flintapp .NavBar > .hamSection',
      '$hamContents': '#_flintapp hamContents.NavBar, #_flintapp .NavBar.hamContents, #_flintapp .ViewNavBar.hamContents, #_flintapp .NavBar > .hamContents',
      '$hamHeader': '#_flintapp hamHeader.NavBar, #_flintapp .NavBar.hamHeader, #_flintapp .ViewNavBar.hamHeader, #_flintapp .NavBar > .hamHeader',
      '$hamCategory': '#_flintapp hamCategory.NavBar, #_flintapp .NavBar.hamCategory, #_flintapp .ViewNavBar.hamCategory, #_flintapp .NavBar > .hamCategory',
      '$mobileLogo': '#_flintapp mobileLogo.NavBar, #_flintapp .NavBar.mobileLogo, #_flintapp .ViewNavBar.mobileLogo, #_flintapp .NavBar > .mobileLogo',
      '$logo': '#_flintapp logo.NavBar, #_flintapp .NavBar.logo, #_flintapp .ViewNavBar.logo, #_flintapp .NavBar > .logo',
      '$menus': '#_flintapp menus.NavBar, #_flintapp .NavBar.menus, #_flintapp .ViewNavBar.menus, #_flintapp .NavBar > .menus',
      '$PRMenu': '#_flintapp .ViewNavBar .ViewPRMenu'
    }, {
      '$': {
        alignSelf: 'stretch'
      },
      '$mobileMode': {
        position: 'absolute',
        width: '100%',
        left: 0,
        zIndex: 100,
        background: 'rgb(248, 236, 240)',
        height: 50,
        flexGrow: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      '$desktopMode': {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'stretch',
        justifyContent: 'stretch',
        flexGrow: 1
      },
      '$logoSec': {
        flexGrow: 1,
        paddingLeft: 8
      },
      '$hamSection': {
        flexGrow: 1
      },
      '$hamContents': {
        background: 'rgb(190, 173, 179)',
        width: 250
      },
      '$hamHeader': {
        background: 'rgb(114, 91, 98)',
        color: 'white',
        alignSelf: 'stretch',
        padding: [4, 8]
      },
      '$hamCategory': {
        alignSelf: 'stretch'
      },
      '$mobileLogo': {
        marginRight: 10
      },
      '$logo': {
        width: 200,
        height: 23
      },
      '$menus': {
        flexDirection: 'row',
        flexGrow: 1,
        alignSelf: 'flex-end',
        marginRight: 8,
        justifyContent: 'flex-end',
        height: 50,
        alignItems: 'center'
      },
      '$PRMenu': {
        marginLeft: 40
      }
    });
    Flint.view('NavBar', function (view, on, $) {
      var context = initContext(view, {
        route: atom(),
        width: atom(),
        isMobile: atom()
      });

      var HAM_STYLE = {
        alignSelf: 'stretch',
        alignItems: 'stretch',
        link: {
          padding: 12,
          borderBottom: '1px solid #ddd',
          background: 'rgba(255, 255, 255, 0.8)',
          whiteSpace: 'nowrap'
        }
      };view.render(function () {
        return Flint.iff(context.isMobile.get()) && view.el(
          ['mobileMode', 1],
          { if: context.isMobile.get() },
          view.el(
            ['hamSection', 1],
            null,
            view.el(
              ['HamburgerMenu', 1],
              null,
              view.el(
                ['hamContents', 1],
                null,
                view.el(
                  ['NavLink', 1],
                  { style: HAM_STYLE, to: '/' },
                  'Home'
                ),
                view.el(
                  ['NavLink', 2],
                  { style: HAM_STYLE, to: '/about' },
                  'About'
                ),
                view.el(
                  ['hamCategory', 1],
                  null,
                  view.el(
                    ['hamHeader', 1],
                    null,
                    'Shows'
                  ),
                  view.el(
                    ['NavLink', 3],
                    { style: HAM_STYLE, to: 'http://thegirlsgame.tv' },
                    'The Girl\'s Game'
                  )
                ),
                view.el(
                  ['hamCategory', 2],
                  null,
                  view.el(
                    ['hamHeader', 2],
                    null,
                    'Products'
                  ),
                  view.el(
                    ['NavLink', 4],
                    { style: HAM_STYLE, to: 'https://mrright.net' },
                    'Mr. Right'
                  ),
                  view.el(
                    ['NavLink', 5],
                    { style: HAM_STYLE, to: '/3sa' },
                    '3 Second Attraction'
                  ),
                  view.el(
                    ['NavLink', 6],
                    { style: HAM_STYLE, to: '/enchant-mr-right' },
                    'Enchant Mr. Right'
                  ),
                  view.el(
                    ['NavLink', 7],
                    { style: HAM_STYLE, to: 'https://texting.tips' },
                    'Texting Tips'
                  )
                ),
                view.el(
                  ['hamCategory', 3],
                  null,
                  view.el(
                    ['hamHeader', 3],
                    null,
                    'Coaching'
                  ),
                  view.el(
                    ['NavLink', 8],
                    { style: HAM_STYLE, to: '/residential/men' },
                    'Men\'s Residential'
                  ),
                  view.el(
                    ['NavLink', 9],
                    { style: HAM_STYLE, to: '/residential/women' },
                    'Women\'s Residential'
                  )
                ),
                view.el(
                  ['hamCategory', 4],
                  null,
                  view.el(
                    ['hamHeader', 4],
                    null,
                    ' '
                  ),
                  view.el(
                    ['NavLink', 10],
                    { style: HAM_STYLE, to: '/contact' },
                    'Contact'
                  ),
                  view.el(
                    ['NavLink', 11],
                    { style: HAM_STYLE, to: '/terms' },
                    'Privacy & Terms'
                  )
                )
              )
            )
          ),
          view.el(
            ['NavLink', 12],
            { className: 'mobileLogo', to: '/' },
            view.el(['img', 1], { className: 'logo', src: '/images/pr-logo.png' })
          )
        );
      });view.render(function () {
        return Flint.iff(!context.isMobile.get()) && view.el(
          ['desktopMode', 1],
          { if: !context.isMobile.get() },
          Flint.iff(context.route.get() != '/') && view.el(
            ['logoSec', 1],
            { if: context.route.get() != '/' },
            view.el(
              ['NavLink', 13],
              { to: '/' },
              view.el(['img', 2], { className: 'logo', src: '/images/pr-logo.png' })
            )
          ),
          view.el(
            ['menus', 1],
            null,
            view.el(
              ['NavLink', 14],
              { to: '/about' },
              'About'
            ),
            view.el(['PRMenu', 1], {
              title: 'Shows',
              options: [{
                label: "The Girl's Game",
                url: 'http://thegirlsgame.tv',
                target: '_blank'
              }]
            }),
            view.el(['PRMenu', 2], {
              title: 'Products',
              options: [{
                label: 'Mr. Right',
                url: 'https://mrright.net',
                target: '_blank'
              }, {
                label: '3 Second Attraction',
                url: '/3sa'
              }, {
                label: 'Enchant Mr. Right',
                url: '/enchant-mr-right'
              }, {
                label: 'Texting Tips',
                url: 'https://texting.tips'
              }]
            }),
            view.el(['PRMenu', 3], {
              title: 'Coaching',
              options: [{
                label: "Men's Residential Weekend",
                url: '/residential/men'
              }, {
                label: "Women's Residential Weekend",
                url: '/residential/women'
              }],
              style: {
                menuWrapper: {
                  right: 0
                }
              }
            })
          )
        );
      });

      $["$"] = function (_, _index) {
        return { height: context.isMobile.get() ? 50 : null
        };
      };

      '483f2ebc';
      '20e45d34';
      '6d0a0c9c';
      '6d0a0c9c';
      '57bd1d02';
      '7ad33e1c';
      '7ad33e1c';
      '486109c8';
      '1f81b058';
      '6b2e9433';
      '41d97eaa';
    });
  })
})();
//# sourceMappingURL=navBar.js.map
